<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Desarrollo de Apps</h1>
      </div>
    </div>
  </div>
</header>

<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Apps y plataformas para escalar tu <span class="highlight-green">operación digital</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Creamos aplicaciones móviles y empresariales con enfoque en experiencia, seguridad y crecimiento.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Pruebas rigurosas y seguridad</li>
          <li><i class="bi bi-check-circle-fill"></i> Escalabilidad y rendimiento</li>
          <li><i class="bi bi-check-circle-fill"></i> Experiencia de usuario optimizada</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-phone"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-apple"></i>
          </div>
          <h4 class="modern-service-card-title">iOS & Android</h4>
          <p>Creamos aplicaciones nativas e híbridas con diseño intuitivo, alto rendimiento y seguridad robusta.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-briefcase"></i>
          </div>
          <h4 class="modern-service-card-title">Apps Empresariales</h4>
          <p>Creamos soluciones para optimizar procesos internos, mejorar operación y aumentar eficiencia.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-palette"></i>
          </div>
          <h4 class="modern-service-card-title">Diseño UI/UX</h4>
          <p>Diseñamos interfaces modernas y flujos de navegación orientados a conversión y uso real.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Equipo experto en tecnologías modernas</li>
          <li><i class="bi bi-check-circle-fill"></i> Transparencia y colaboración continua</li>
          <li><i class="bi bi-check-circle-fill"></i> Soporte y acompañamiento post-lanzamiento
          </li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Convierte tu idea en una plataforma digital lista para crecer.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
